export const SECTION_SIDEBAR_WIDTH = 264
export const SECTION_SIDEBAR_MAX_WIDTH = 420
export const SECTION_SIDEBAR_WIDTH_STORAGE_KEY = 'trellis-section-sidebar-width'
